module.exports = __webpack_public_path__ + "img/java.c20368e3.png";